import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { P } from '@components/shared/Typography';
import CrossIcon from '@images/cross.svg';
import { Context } from './Context';

export default function StatusBar() {
  const { state, dispatch } = useContext(Context);
  const { statusMessage } = state;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!statusMessage) return;
    const a = setTimeout(() => {
      setShow(true);
    }, 300);

    const b = setTimeout(() => {
      setShow(false);
      cleanupMessage();
    }, 4000);

    return () => {
      clearTimeout(a);
      clearTimeout(b);
    };
  }, [statusMessage]);

  function cleanupMessage() {
    setTimeout(() => {
      setShow(false);
    }, 200);
    dispatch({ type: 'setStatusMessage', data: false });
  }

  function handleClose() {
    setShow(false);
  }

  return (
    <Container $show={show}>
      <FlexBalance />
      <PStyled $mods={[16, 'white', 'center']} $mobileMods={['left']}>
        {statusMessage}
      </PStyled>
      <CrossContainer>
        <CrossStyled onClick={handleClose} />
      </CrossContainer>
    </Container>
  );
}

interface IP {
  $show: boolean;
}

const Container = styled.div<IP>`
  width: 100%;
  background: #00391e;
  position: fixed;
  z-index: 9999;
  overflow: hidden;
  transition: top 0.2s ease-in-out;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 26px;
  top: ${(props) => (props.$show ? 0 : '-74px')};
  @media (max-width: 768px) {
    padding: 0 20px 0 16px;
  }
`;

const PStyled = styled(P)`
  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const FlexBalance = styled.div`
  margin-bottom: 5px;
  width: 40px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const CrossContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  width: 40px;
`;

const CrossStyled = styled(CrossIcon)`
  * {
    fill: white;
  }
  &:hover {
    cursor: pointer;
    * {
      fill: #edb034;
    }
  }
`;
